var CommonFunctions = {
  filters: {
    number(value, number) {
      if (value && typeof value == "number") {
        var num = 0;
        if (number && typeof number == "number") {
          num = value.toFixed(number);
        } else if (number == 0) {
          num = value.toFixed(0);
        } else {
          num = value.toFixed(4);
        }
        num += "";
        var x = num.split(".");
        var x1 = x[0];
        var x2 = x.length > 1 ? "." + x[1] : "";
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, "$1" + "," + "$2");
        }
        return x1 + x2;
      } else {
        throw "arguments are not valid numbers";
      }

      return value;
    },
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
  },
  methods: {
    printData: function (DOMid, title) {
      var printContents = document.getElementById(DOMid).innerHTML;
      var popupWin = window.open("", "_blank", "width=800,height=600");
      popupWin.document.open();
      popupWin.document.write(
        `<html><head> <style>
        body {
          font-family: Trebuchet MS;
        }
        table {
          border-collapse: collapse;
          width: 100%;
        }
        .print {
          display: none;
        }
        table th,
        td {
          border: solid 1px #c6c6c6;
          padding: 5px;
        }
        table th a {
          color: #000;
          text-decoration: none;
        }
        
        </style></head><body onload="window.print();"><div><center><h2>` +
        title +
        "</h2></center>" +
        printContents +
        "</div></html>"
      );
      for (let el of popupWin.document.getElementsByClassName("Print"))
        el.style.visibility = "hidden";
    },
    Pagination(Data, sp, cp) {
      if (!Data) {
        return [];
      }
      var initial = sp * cp - sp; // pagesize * pageNo - pagesize
      var max = Data.length - initial < sp ? Data.length : sp * cp; //select maximum
      var _arr = [];
      for (var n = initial; n < max; n++) {
        _arr.push(Data[n]);
      }
      return _arr;
    },
    exportToCsv(filename, rows) {
      var processRow = function (row) {
        var finalVal = "";
        for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] === null ? "" : row[j].toString();
          if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
          }
          var result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
          if (j > 0) finalVal += ",";
          finalVal += result;
        }
        return finalVal + "\n";
      };

      var csvFile = "";
      for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
      }

      var blob = new Blob([csvFile], {
        type: "text/csv;charset=utf-8;"
      });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    ObjectToCSV(filename, obj, keys, titles = null, dateFormat = null) {
      if (!keys && !keys instanceof Array) {
        throw "keys should be array";
      }
      if (!obj && !obj instanceof Object) {
        throw "obj is not valid";
      }
      var _arryKeys = [keys];
      var MyArray = obj.map(function (object) {
        var _arr = keys.map(function (ob) {
          return object[ob];
        });
        return _arr;
      });
      var res = [];
      if (titles) {
        res = [
          [...titles], ...MyArray
        ];
      } else {
        res = [..._arryKeys, ...MyArray];
      }
      this.exportToCsv(filename, res);
    },

    DynamicSort(property, dir) {
      var sortOrder = 1;

      if (dir === "desc") {
        sortOrder = -1;
        //property = property.substr(1);
      }

      return function (a, b) {
        if (typeof a[property] == "number" && typeof b[property] == "number") {
          if (sortOrder == -1) {
            if (b[property] > a[property]) {
              return 1;
            } else if (b[property] < a[property]) {
              return -1;
            } else {
              return 0;
            }
          } else {
            if (a[property] > b[property]) {
              return 1;
            } else if (a[property] < b[property]) {
              return -1;
            } else {
              return 0;
            }
          }
        } else {
          if (sortOrder == -1) {
            return b[property].localeCompare(a[property]);
          } else {
            return a[property].localeCompare(b[property]);
          }
        }
      };
    },

    Sort(data, property, dir) {
      data.sort(this.DynamicSort(property, dir));
      return data;
    },
    setFormDate(_date) {
      var date = new Date();
      if (_date) {
        date = new Date(_date);
      }
      var setdate =
        ("0" + date.getDate()).slice(-2) +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        date.getFullYear();

      return setdate;
    },
    GetCorrectFormat(date) {
      if (date) {
        var _date = date.split("-");
        return _date[2] + "-" + _date[1] + "-" + _date[0];
      }
      throw "aurgument supplied to GetCorrectFormat is invalid ";
    },

    setDate(_date) {
      var date = new Date();
      if (_date) {
        date = new Date(_date);
      }
      var setdate =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);

      return setdate;
    },
    Timestrap(_date, UseFullMonth = true) {
      if (_date == null || _date == "") {
        return "";
      }
      const FullMonth = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      var date = new Date(_date);
      if (date) {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var dt = date.getDate();
        dt = dt < 10 ? "0" + dt : dt;
        var hrs = date.getHours();
        var mns = date.getMinutes();
        var tm = hrs < 12 ? "AM" : "PM";
        var sec = date.getSeconds();
        //var ms = date.getMilliseconds();
        hrs = hrs % 12;
        if (UseFullMonth) {
          return (
            dt +
            "-" +
            FullMonth[month - 1] +
            "-" +
            year +
            " " +
            (hrs < 10 ? "0" + hrs : hrs) +
            ":" +
            (mns < 10 ? "0" + mns : mns) +
            ":" +
            (sec < 10 ? "0" + sec : sec) +
            //"." +
            //  ms +
            " " +
            tm
          );
        }
        return (
          dt +
          "-" +
          month +
          "-" +
          year +
          " " +
          (hrs < 10 ? "0" + hrs : hrs) +
          ":" +
          (mns < 10 ? "0" + mns : mns) +
          ":" +
          (sec < 10 ? "0" + sec : sec) +
          //"." +
          //  ms +
          " " +
          tm
        );
      }
      throw "argument supplied to Timestramp() are invalid";
    },
    DateFromat(date, FullMonthName) {
      var _date = new Date(date);
      if (Object.prototype.toString.call(_date) === "[object Date]") {
        //var _date = new Date(date);
        const months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ];
        const FullMonth = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ];
        var day = _date.getDate();
        day = day < 10 ? "0" + day : day;
        var monthIndex = _date.getMonth();
        var year = _date.getFullYear();
        if (FullMonthName) {
          return day + " " + FullMonth[monthIndex] + " " + year;
        }
        return day + " " + months[monthIndex] + " " + year;
      }
      throw "Invalid date argument to Dateformat function.";
    }
  }
};

export default CommonFunctions;